class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.header = document.querySelector(".header-wrapper");
    this.detailsContainer = this.querySelector("details");
    this.summaryToggle = this.querySelector("summary");
    this.header.preventHide = false;

    this.detailsContainer.addEventListener(
      "keyup",
      (event) => event.code === "Escape" && this.isOpen() && this.close()
    );
    this.summaryToggle.addEventListener(
      "click",
      this.onSummaryClick.bind(this)
    );

    this.summaryToggle.setAttribute("role", "button");

    // The mobile close (x) button can be relocated out of <summary> (e.g. the header search
    // bar moves into the dropdown panel on mobile), so it can no longer rely on bubbling up to
    // the summary's click handler above - wire it directly instead, wherever it currently lives.
    this.querySelectorAll(".header__search-mobile-close").forEach((closeButton) => {
      closeButton.addEventListener("click", (event) => {
        event.preventDefault();
        event.stopPropagation();
        this.close();
      });
    });
  }

  isOpen() {
    return this.detailsContainer.hasAttribute("open");
  }

  getFocusContainer() {
    const panel = this.querySelector('.header__search-inner');
    return panel?.getAttribute('aria-modal') === 'true' ? panel : this.detailsContainer;
  }

  onSummaryClick(event) {
    event.preventDefault();
    if (event.target.closest("details").hasAttribute("open")) {
      this.close();
      this.header.preventHide = false;
    } else {
      this.open(event);
      if (!this.header) return;
      this.header.preventHide = this.detailsContainer.open;
    }
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains("modal-overlay"))
      this.close(false);
  }

  open(event) {
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    const details = event && event.target ? event.target.closest("details") : this.detailsContainer;
    details.setAttribute("open", true);
    this.header.preventHide = true;
    document.body.addEventListener("click", this.onBodyClickEvent);
    document.body.classList.add("overflow-hidden");

    trapFocus(
      this.getFocusContainer(),
      this.detailsContainer.querySelector('input:not([type="hidden"])')
    );

    if (this.header.parentNode.classList.contains('color-background-overlay') && this.classList.contains('header__search')) {
      this.header.parentNode.classList.remove('color-background-overlay');
      this.header.parentNode.classList.add('color-background-overlay-hidden');
    }

    if (this.classList.contains('header__search')) {
      document.querySelector('.header__overlay')?.classList.add('active');
      document.querySelector('header-drawer')?.style.setProperty('display', 'none', 'important');
      document.querySelector('.menu-drawer-container')?.style.setProperty('display', 'none', 'important');
    }
  }

  close(focusToggle = true) {
    this.querySelector('predictive-search')?.close();
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute("open");
    document.body.removeEventListener("click", this.onBodyClickEvent);
    document.body.classList.remove("overflow-hidden");
    this.header.preventHide = false;

    if (this.header.parentNode.classList.contains('color-background-overlay-hidden') && this.classList.contains('header__search')) {
      const colorScheme = document.querySelector('main').querySelectorAll('.shopify-section')[0]?.querySelector('[data-header-transparent]')?.getAttribute('data-header-transparent-color-scheme');
      this.header.parentNode.classList.remove('color-background-overlay-hidden');
      this.header.parentNode.classList.add('color-background-overlay');
      if (colorScheme)
        this.header.parentNode.classList.add(colorScheme);
    }

    document.querySelector('.header__overlay')?.classList.remove('active');

    if (this.classList.contains('header__search')) {
      document.querySelector('header-drawer')?.style.removeProperty('display');
      document.querySelector('.menu-drawer-container')?.style.removeProperty('display');
    }
  }
}

customElements.define("details-modal", DetailsModal);
